/* rv-benefits4.js — scroll-gates the section wrapper's fade-up (original code).
   The wrapper's 0.8s fade-up runs at load by default. The inline script inside the wrapper pauses it before first
   paint (.rv-benefits4--gated); this file marks the wrapper as watched and swaps --gated for --in-view when the
   section enters the viewport. Fail-visible by design: if this file never runs, the inline script lifts the gate
   itself on window load / after 3 s, and with scripts off the animation simply plays at load. */
(function () {
  var CLASS_GATED = 'rv-benefits4--gated';
  var CLASS_IN_VIEW = 'rv-benefits4--in-view';
  var ATTR_WATCHED = 'data-rv-b4-watched';
  var SAFETY_MS = 3000;

  function reveal(el) {
    el.classList.remove(CLASS_GATED);
    el.classList.add(CLASS_IN_VIEW);
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < h;
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.rv-benefits4:not(.' + CLASS_IN_VIEW + ')');
    if (!sections.length) return;
    var observer = null;
    if ('IntersectionObserver' in window) {
      try {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            observer.unobserve(entry.target);
          });
        }, { threshold: 0 });
      } catch (e) {
        observer = null;
      }
    }
    Array.prototype.forEach.call(sections, function (el) {
      el.setAttribute(ATTR_WATCHED, '');
      if (!observer) { reveal(el); return; }
      observer.observe(el);
      /* Safety net that keeps the scroll gate: if the observer has not fired but the section is on screen, reveal. */
      window.setTimeout(function () {
        if (!el.classList.contains(CLASS_IN_VIEW) && onScreen(el)) {
          reveal(el);
          observer.unobserve(el);
        }
      }, SAFETY_MS);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
